var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ml-8"},[_vm._v(_vm._s(_vm.url))]),_vm._v(" "),_c('Button',{staticClass:"button--rounded button--primary px-10 ma-8",attrs:{"height":"48"},on:{"click":_vm.getVcard}},[_vm._v("\n    Get vCard\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }